import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import _ from 'lodash'
import moment from '../../../lib/moment.js'

import { Button } from 'reactstrap'
import { authSelector, employeeLevelsSelector } from './../../../selectors'
import { employeeLevelsAction } from './../../../actions/'
import CustomModalMessage from '../../../components/modal-message'
import EmployeeLevelForm from '../../../components/employee-levels'

class CreatEmployeeLevels extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      level_code: '',
      start_date: '',
      is_active: true,
      employeeLevel: '',
      edit: false,
      id: '',
      activeTab: '1',
    }
    this.handleInput = this.handleInput.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.deactivateEmployeeLevel = this.deactivateEmployeeLevel.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleDiscard = this.handleDiscard.bind(this)
  }
  componentDidMount() {
    if (_.get(this.props, 'edit.edit')) {
      this.props.getEmployeeLevels(_.get(this.props, 'edit.id'), localStorage.getItem('access_token'))
    }
  }
  componentWillReceiveProps(nextProps) {
    if (_.get(nextProps, 'employeeLevelsGet')) {
      this.setState({
        level_code: _.get(nextProps, 'employeeLevelsGet.level_code'),
        employeeLevel: _.get(nextProps, 'employeeLevelsGet.name'),
        start_date: _.get(nextProps, 'employeeLevelsGet.start_date'),
        is_active: _.get(nextProps, 'employeeLevelsGet.is_active'),
      })
      this.props.resetGetEmployeeLevels()
    }
    if (_.get(nextProps, 'edit')) {
      if (_.get(nextProps, 'edit.edit')) {
        this.setState({ id: _.get(nextProps, 'edit.id'), edit: false })
        this.props.handleClickEdit(false, '')
        this.props.getEmployeeLevels(_.get(nextProps, 'edit.id'), localStorage.getItem('access_token'))
        this.props.resetGetEmployeeLevels()
      }
      this.setState({
        edit: false,
      })
    }
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleClickEdit() {
    this.setState({ edit: true })
  }
  handleDelete() {
    this.deactivateEmployeeLevel()
    this.props.cancelDelete()
    this.props.handleSpan(false)
  }
  handleDiscard() {
    this.props.cancelDiscard()
    this.props.handleSpan(false)
  }
  deactivateEmployeeLevel() {
    this.props.deactivateEmployeeLevels(_.get(this.state, 'id'), localStorage.getItem('access_token'))
  }
  submitForm() {
    if (_.get(this.state, 'edit')) {
      this.props.editEmployeeLevels(
        _.get(this.state, 'id'),
        {
          level_code: this.state.level_code,
          name: this.state.employeeLevel,
          start_date: new moment(this.state.start_date),
          is_active: this.state.is_active,
        },
        localStorage.getItem('access_token'))
    }
  }
  render() {
    const button = (
      <div>
        <NewButton outline color="danger" onClick={ () => this.props.showDelete('confirmDelete') }>Delete</NewButton>
        <NewButton color="success" onClick={ this.state.edit ? this.submitForm : this.handleClickEdit }>{ this.state.edit ? 'Save' : 'Edit' }</NewButton>
      </div>
    )
    const buttonDelete = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDelete }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDelete }>Delete</NewButton>
      </div>
    )
    const buttonDiscard = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDiscard }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDiscard }>Discard</NewButton>
      </div>
    )
    return (
      <div>
        { _.get(this.props, 'confirmType') === 'confirmDelete' &&
          <CustomModalMessage
            hide={ this.props.cancelDelete }
            show={ _.get(this.props, 'confirmType') === 'confirmDelete' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonDelete }
          />
        }
        { _.get(this.props, 'confirmType') === 'confirmDiscard' &&
        <CustomModalMessage
          hide={ this.props.cancelDiscard }
          show={ _.get(this.props, 'confirmType') === 'confirmDiscard' }
          type={ _.get(this.props, 'confirmStatus') }
          message={ _.get(this.props, 'confirmMessage') }
          button={ buttonDiscard }
        />
        }
        <EmployeeLevelForm
          edit={ this.state.edit }
          level_code={ this.state.level_code }
          employeeLevel={ this.state.employeeLevel }
          start_date={ this.state.start_date }
          is_active={ this.state.is_active }
          button={ button }
          confrim={ _.get(this.props, 'confirm') }
          submitForm={ this.submitForm }
          handleClickEdit={ this.handleClickEdit }
          handleSpan={ this.props.handleSpan }
          handleInput={ this.handleInput }
          cancelForm={ this.props.cancelForm }
          showDiscard={ this.state.edit ? this.props.showDiscard : () => this.props.handleSpan(false) }
        />
      </div>
    )
  }
}

CreatEmployeeLevels.propTypes = {
  editEmployeeLevels: PropTypes.func.isRequired,
  getEmployeeLevels: PropTypes.func.isRequired,
  resetGetEmployeeLevels: PropTypes.func.isRequired,
  deactivateEmployeeLevels: PropTypes.func.isRequired,
  cancelDelete: PropTypes.func.isRequired,
  handleClickEdit: PropTypes.func.isRequired,
  showDelete: PropTypes.func.isRequired,
  handleSpan: PropTypes.func.isRequired,
  cancelDiscard: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  authData: authSelector.getUserData,
  employeeLevelsCreate: employeeLevelsSelector.getCreateEmployeeLevelsData,
  employeeLevelsEdit: employeeLevelsSelector.getEditEmployeeLevelsData,
  employeeLevelsGet: employeeLevelsSelector.getGetEmployeeLevelsData,
  employeeLevelsDeactivate: employeeLevelsSelector.getDeactivateEmployeeLevelsData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  createEmployeeLevels: employeeLevelsAction.createEmployeeLevels,
  resetCreateEmployeeLevels: employeeLevelsAction.resetCreateEmployeeLevels,
  editEmployeeLevels: employeeLevelsAction.editEmployeeLevels,
  resetEditEmployeeLevels: employeeLevelsAction.resetEditEmployeeLevels,
  getEmployeeLevels: employeeLevelsAction.getEmployeeLevelsByID,
  resetGetEmployeeLevels: employeeLevelsAction.resetGetEmployeeLevels,
  deactivateEmployeeLevels: employeeLevelsAction.deactivateEmployeeLevels,
  resetDeactivateEmployeeLevels: employeeLevelsAction.resetDeactivateEmployeeLevels,
  listEmployeeLevels: employeeLevelsAction.getEmployeeLevels,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CreatEmployeeLevels)

const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`



// WEBPACK FOOTER //
// ./src/pages/employee-levels/edit/index.js